import React from "react";
import { Helmet } from "react-helmet";

import Header from "./components/Header";
import Footer from "./components/Footer";

import "./css/contactstyle.css";

const Contact = () => {
  return (
    <>
      <Helmet>
        <title>Contact Us - Krisula GlobExim</title>

        <meta charSet="UTF-8" />

        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        />

        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css"
        />
      </Helmet>

      {/* HEADER */}
      <Header />

      {/* HERO */}
      <section className="hero">
        <div className="overlay"></div>

        <div className="hero-content">
          <h1>Contact Us</h1>

          <div className="breadcrumb">
            <span>Home</span>
            <span>/</span>
            <span>Contact Us</span>
          </div>
        </div>
      </section>

      {/* OFFICES */}
      <section className="contact-section">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Get In Touch</span>
            <h2>Our Offices</h2>
          </div>

          <div className="office-grid">
            <div className="office-card">
              <i className="fa-solid fa-location-dot"></i>
              <h3>Pune - Maharashtra (INDIA)</h3>
              <p>
                210, 2nd Floor, Mahalaxmi Market, Pune, Maharashtra
              </p>
            </div>

            <div className="office-card">
              <i className="fa-solid fa-building"></i>
              <h3>Mumbai - Maharashtra (INDIA)</h3>
              <p>
                Prabhadevi, Mumbai, Maharashtra (India)
              </p>
            </div>

            <div className="office-card">
              <i className="fa-solid fa-earth-americas"></i>
              <h3>Raleigh - North Carolina (USA)</h3>
              <p>
                Providence, Brier Creek, Raleigh, USA
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* DETAILS + FORM */}
      <section className="details-section">
        <div className="container details-grid">
          {/* LEFT */}
          <div className="details-box">
            <h2>Contact Details</h2>

            <div className="info-item">
              <i className="fa-solid fa-phone"></i>

              <div>
                <h4>Phone</h4>
                <p>(+91)-20-65300005</p>
                <p>(+91)-750 700 2346</p>
              </div>
            </div>

            <div className="info-item">
              <i className="fa-solid fa-envelope"></i>

              <div>
                <h4>Email</h4>
                <p>info@krisulaglobexim.com</p>
                <p>krisulaglobexim@gmail.com</p>
              </div>
            </div>

            <div className="info-item">
              <i className="fa-solid fa-globe"></i>

              <div>
                <h4>Website</h4>
                <p>www.krisulaglobexim.com</p>
              </div>
            </div>
          </div>

          {/* RIGHT FORM */}
          <div className="contact-form-box">
            <h2>Send Message</h2>

            <form className="contact-form">
              <input type="text" placeholder="Your Name" required />

              <input type="email" placeholder="Email Address" required />

              <input type="text" placeholder="Phone Number" />

              <textarea rows="6" placeholder="Your Message"></textarea>

              <button type="submit">Submit</button>
            </form>
          </div>
        </div>
      </section>

      {/* TEAM */}
      <section className="persons-section">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Team</span>
            <h2>Contact Persons</h2>
          </div>

          <div className="persons-grid">
            <div className="person-card">
              <i className="fa-solid fa-user"></i>
              <h3>Mr. Krishna Bhagat</h3>
              <p>Director</p>
              <p>+91-865 556 0033</p>
              <p>krishna@krisulaglobexim.com</p>
            </div>

            <div className="person-card">
              <i className="fa-solid fa-user"></i>
              <h3>Mrs. Sulabha Gawali</h3>
              <p>Director-Founder</p>
              <p>+91-720 830 6550</p>
              <p>sulabha@krisulaglobexim.com</p>
            </div>
          </div>
        </div>
      </section>

      {/* MAP */}
      <section className="map-section">
        <iframe
          title="map"
          src="https://www.google.com/maps?q=Garhmukteshwar%20Uttar%20pradesh&output=embed"
          loading="lazy"
        ></iframe>
      </section>

      {/* FOOTER */}
      <Footer />
    </>
  );
};

export default Contact;